var map = {
	"./black/chakanjietu2.png": "hx5u",
	"./blue/chakanjietu2.png": "3djq",
	"./white/chakanjietu2.png": "sGA7"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "nroV";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom ^\.\/.*\/chakanjietu2\.png$
// module id = nroV
// module chunks = 24